<template>
    <div id="facturations" role="tabpanel">

    </div>
</template>
<script>
export default {
    name: 'FacturationsTab'
}
</script>